module.exports = "/images/understanding-risk-1.jpeg?33ac306759d4b3161144535c3089c2c9";